<template>
  <header class="navbar" id="nav">
    <nav class="navbar-desktop">
  
      <div class="navbar-left">
        <router-link to="/" class="logo">
          <img :src="logo" alt="Logo" />
        </router-link>
        <div class="tabs">
          <button @click="toggleDropdown('collection')">БРЕНДИ</button>
          <button @click="toggleDropdown('skinType')">ТИПИ ШКІРИ</button>
          <button @click="toggleDropdown('productType')">ТИП ПРОДУКТУ</button>
          <button v-if='is_active' @click="go_to_collections('productType')">Спеціальна пропозиція</button>
        </div>
      </div>
      <div class="navbar-right">
        <button class="icon" @click="toggleSearch">
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  height="18px"><path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"></path></svg>
        </button>
      
        <router-link class="icon" to="/account/" @click="closeAll">
          <svg viewBox="0 0 16.9 20.1" height="18px" class="search-icon">
            <path d="M12.5,5.6c0,2.7-1.4,4.9-4.1,4.9S4.3,8.3,4.3,5.6s1.4-4.9,4.1-4.9S12.5,2.8,12.5,5.6z"></path>
            <path d="M15.8,18.7H1c0-3.2,2.6-5.7,5.7-5.7l0,0H10C13.2,12.9,15.8,15.5,15.8,18.7z"></path>
          </svg>
        </router-link>
        <button class="icon" @click="toggleWishlist">
          <svg viewBox="0 0 30 30" height="18px"><g transform="matrix(1.2433,0,0,1.2433,-214.644,-2.18133)"><path d="M195.696,16.572C198.023,12.835 197.503,8.361 194.946,6.237C192.162,3.925 187.731,4.353 185.563,7.658C183.305,4.109 178.792,3.881 176.017,6.24C173.145,8.681 173.363,13.152 175.192,16.347C178.404,21.959 185.344,24.531 185.344,24.531C185.439,24.566 185.544,24.564 185.637,24.526C185.637,24.526 192.528,21.66 195.696,16.572ZM195.014,16.146C192.234,20.611 186.467,23.284 185.476,23.72C184.479,23.322 178.696,20.85 175.89,15.947C174.245,13.074 173.956,9.048 176.538,6.853C179.101,4.674 183.358,5.024 185.2,8.645C185.269,8.779 185.407,8.864 185.558,8.864C185.708,8.865 185.847,8.781 185.916,8.647C187.662,5.269 191.854,4.715 194.432,6.856C196.73,8.764 197.104,12.79 195.014,16.146Z"/></g></svg>
          <span v-if="cartCount > 0" class="header__qty">{{ wishlistItemCount }}</span>
        </button>
        <button class="icon" @click="toggleCart">
        <svg viewBox="0 0 23.8 19" height="18px">
          <path d="M8,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C8.5,15.4,8.3,15.7,8,15.7	C8,15.7,8,15.7,8,15.7z"></path>
          <path d="M12.2,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C12.7,15.4,12.5,15.7,12.2,15.7	C12.2,15.7,12.2,15.7,12.2,15.7z"></path>
          <path d="M16.4,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C16.9,15.4,16.6,15.7,16.4,15.7	C16.4,15.7,16.4,15.7,16.4,15.7z"></path>
          <path d="M23.3,6.8h-11L17,0.8c0.1-0.2,0.1-0.5-0.1-0.6c-0.2-0.2-0.5-0.2-0.7,0l-5.2,6.5H0.5C0.2,6.8,0,7,0,7.3s0.2,0.5,0.5,0.5h1.4	l2.9,10.9C4.8,18.8,5,19,5.1,19h14.1c0.2,0,0.3-0.1,0.4-0.3l2.9-10.9h0.9c0.3,0,0.5-0.2,0.5-0.5C23.8,7,23.6,6.8,23.3,6.8z M21.3,8	l-2.5,9.6c0,0.2-0.2,0.4-0.4,0.4H5.9c-0.2,0-0.3-0.1-0.4-0.3L2.9,8c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0.1,0h18C21.3,7.7,21.3,7.8,21.3,8	C21.4,8,21.4,8,21.3,8z"></path>
        </svg>
        <!-- Індикатор кількості товарів у корзині -->
        <span v-if="cartCount > 0" class="header__qty">{{ cartCount }}</span>
      </button>

      </div>
    </nav>
    
    <!-- Search Bar -->
    <div v-if="showSearch" class="search-bar">
      <input v-model="searchQuery" type="text" placeholder="Пошук продукту..." @input="onSearchInput"/>
      <button @click="clearSearch">
        Очистити
      </button>
      <!-- Хрестик для закриття пошуку -->
      <button @click="toggleSearch" class="close-search">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <!-- Mobile Navbar -->
    <nav class="navbar-mobile">
      <div class="navbar-left">
        <button @click="toggleSidebar" class="burger-menu">
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"></path></svg>
        </button>
        <a href="/" class="logo">
          <img :src="logo" alt="Logo" />
        </a>
      </div>
      <div class="navbar-right">
        <button class="icon" @click="toggleSearch">
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  height="18px"><path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"></path></svg>
        </button>
        <button class="icon" @click="toggleWishlist">
          <svg viewBox="0 0 30 30" height="18px"><g transform="matrix(1.2433,0,0,1.2433,-214.644,-2.18133)"><path d="M195.696,16.572C198.023,12.835 197.503,8.361 194.946,6.237C192.162,3.925 187.731,4.353 185.563,7.658C183.305,4.109 178.792,3.881 176.017,6.24C173.145,8.681 173.363,13.152 175.192,16.347C178.404,21.959 185.344,24.531 185.344,24.531C185.439,24.566 185.544,24.564 185.637,24.526C185.637,24.526 192.528,21.66 195.696,16.572ZM195.014,16.146C192.234,20.611 186.467,23.284 185.476,23.72C184.479,23.322 178.696,20.85 175.89,15.947C174.245,13.074 173.956,9.048 176.538,6.853C179.101,4.674 183.358,5.024 185.2,8.645C185.269,8.779 185.407,8.864 185.558,8.864C185.708,8.865 185.847,8.781 185.916,8.647C187.662,5.269 191.854,4.715 194.432,6.856C196.73,8.764 197.104,12.79 195.014,16.146Z"/></g></svg>
          <span v-if="cartCount > 0" class="header__qty">{{ cartCount }}</span>
        </button>
        <button class="icon" @click="toggleCart">
          <svg viewBox="0 0 23.8 19"  height="18px"><path d="M8,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C8.5,15.4,8.3,15.7,8,15.7	C8,15.7,8,15.7,8,15.7z"></path><path d="M12.2,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C12.7,15.4,12.5,15.7,12.2,15.7	C12.2,15.7,12.2,15.7,12.2,15.7z"></path><path d="M16.4,15.7c-0.3,0-0.5-0.2-0.5-0.5v-4.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.6C16.9,15.4,16.6,15.7,16.4,15.7	C16.4,15.7,16.4,15.7,16.4,15.7z"></path><path d="M23.3,6.8h-11L17,0.8c0.1-0.2,0.1-0.5-0.1-0.6c-0.2-0.2-0.5-0.2-0.7,0l-5.2,6.5H0.5C0.2,6.8,0,7,0,7.3s0.2,0.5,0.5,0.5h1.4	l2.9,10.9C4.8,18.8,5,19,5.1,19h14.1c0.2,0,0.3-0.1,0.4-0.3l2.9-10.9h0.9c0.3,0,0.5-0.2,0.5-0.5C23.8,7,23.6,6.8,23.3,6.8z M21.3,8	l-2.5,9.6c0,0.2-0.2,0.4-0.4,0.4H5.9c-0.2,0-0.3-0.1-0.4-0.3L2.9,8c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0.1,0h18C21.3,7.7,21.3,7.8,21.3,8	C21.4,8,21.4,8,21.3,8z"></path></svg>
          <span v-if="cartCount > 0" class="header__qty">{{ cartCount }}</span>
        </button>
      </div>
    </nav>
    <SidebarComponent :showSidebar="showSidebar" @toggle-sidebar="toggleSidebar" />


  </header>
  <!-- Продуктові картки -->
  <div v-if="filteredProducts.length" class="products-grid" >
      <router-link v-for="product in filteredProducts" :key="product.code" :to="`/product/${product.slug}`" custom v-slot="{ href, navigate }" >
        <a :href="href" @click="handleClick(navigate)">
          <div class="product-card" >
        <img :src="product.variants[0]?.images[0]?.image" alt="Product Image" class="product-img">
        <h3>{{ product.name }}</h3>
        <p>{{ product.code }}</p>
        <p v-if="product.variants[0]?.discount_price !== '0.00'" class="price">
          <span class="old-price">{{ product.variants[0].price }} грн</span>
          <span class="discount-price">{{ product.variants[0].discount_price }} грн</span>
        </p>
        <p v-else class="price">{{ product.variants[0].price }} грн</p>
      </div>
      </a>
      </router-link >
  </div>
  <div v-else-if="searchQuery.length >= 2" class="no-results">
      Нічого не знайдено
    </div>
  <Transition>
    <section v-if="activeSection === 'collection'" 
             :class="['content-panel', { 'open': activeSection === 'collection' }]">
      <div class="content-container">
        <div class="container-links">
          <ul class="submenu-links" v-for="brand in brands.brands" :key="brand.name">
            <li class="submenu-grid-items" >
              <a :href="'/collection/'+brand.slug" title="{{ brand.name }}" class="gm-submenu-link">
                <span class='submenu-item-text'>{{ brand.name }}</span> </a>
            </li>
          </ul>
        </div>
        <div class='img_conteiner' >
          <div class="container-imgs" v-for="brand in brands.brands" :key="brand.name">
              <a :href="'/collection/'+brand.slug">
                <img :src="`${baseURL}${brand.home_banner}`" :alt="brand.name" class="product-cart-img lazyloaded">
                <span class="submenu-item-text">{{ brand.name }}</span>
              </a>
          </div>
        </div>

      </div>
    </section>
  </Transition>

  <Transition> 
    <section v-if="activeSection === 'skinType'" 
             :class="['content-panel', { 'open': activeSection === 'skinType' }]" >
      <!-- Content for ТИПИ ШКІРИ -->

      <div class="content-container">
        <div class="container-links">
          <ul class="submenu-links" v-for="skin_type in brands.skin_types" :key="skin_type.name">
            <li class="submenu-grid-items" >
                <a :href="'/skin-type/'+skin_type.slug" class="gm-submenu-link">
                  <span class='submenu-item-text'>{{ skin_type.name }}</span> </a>
              </li>
          </ul>
        </div>

        <div class="container-imgs">
          <a href="#">
            <img srcset="//nichebeautylab.com/cdn/shop/files/1647419900_0_40x.jpg?v=1846326795495253585 40w, //nichebeautylab.com/cdn/shop/files/1647419900_0_100x.jpg?v=1846326795495253585 100w, //nichebeautylab.com/cdn/shop/files/1647419900_0_140x.jpg?v=1846326795495253585 140w, //nichebeautylab.com/cdn/shop/files/1647419900_0_180x.jpg?v=1846326795495253585 180w, //nichebeautylab.com/cdn/shop/files/1647419900_0_250x.jpg?v=1846326795495253585 250w, //nichebeautylab.com/cdn/shop/files/1647419900_0_260x.jpg?v=1846326795495253585 260w, //nichebeautylab.com/cdn/shop/files/1647419900_0_275x.jpg?v=1846326795495253585 275w, //nichebeautylab.com/cdn/shop/files/1647419900_0_305x.jpg?v=1846326795495253585 305w, //nichebeautylab.com/cdn/shop/files/1647419900_0_440x.jpg?v=1846326795495253585 440w, //nichebeautylab.com/cdn/shop/files/1647419900_0_610x.jpg?v=1846326795495253585 610w, //nichebeautylab.com/cdn/shop/files/1647419900_0_720x.jpg?v=1846326795495253585 720w, //nichebeautylab.com/cdn/shop/files/1647419900_0_930x.jpg?v=1846326795495253585 930w, //nichebeautylab.com/cdn/shop/files/1647419900_0_1080x.jpg?v=1846326795495253585 1080w" data-sizes="auto" width="" height="" data-widths="[40, 100, 140, 180, 250, 260, 275, 305, 440, 610, 720, 930, 1080]" class="lazyautosizes lazyloaded" alt="" data-srcset="//nichebeautylab.com/cdn/shop/files/1647419900_0_40x.jpg?v=1846326795495253585 40w, //nichebeautylab.com/cdn/shop/files/1647419900_0_100x.jpg?v=1846326795495253585 100w, //nichebeautylab.com/cdn/shop/files/1647419900_0_140x.jpg?v=1846326795495253585 140w, //nichebeautylab.com/cdn/shop/files/1647419900_0_180x.jpg?v=1846326795495253585 180w, //nichebeautylab.com/cdn/shop/files/1647419900_0_250x.jpg?v=1846326795495253585 250w, //nichebeautylab.com/cdn/shop/files/1647419900_0_260x.jpg?v=1846326795495253585 260w, //nichebeautylab.com/cdn/shop/files/1647419900_0_275x.jpg?v=1846326795495253585 275w, //nichebeautylab.com/cdn/shop/files/1647419900_0_305x.jpg?v=1846326795495253585 305w, //nichebeautylab.com/cdn/shop/files/1647419900_0_440x.jpg?v=1846326795495253585 440w, //nichebeautylab.com/cdn/shop/files/1647419900_0_610x.jpg?v=1846326795495253585 610w, //nichebeautylab.com/cdn/shop/files/1647419900_0_720x.jpg?v=1846326795495253585 720w, //nichebeautylab.com/cdn/shop/files/1647419900_0_930x.jpg?v=1846326795495253585 930w, //nichebeautylab.com/cdn/shop/files/1647419900_0_1080x.jpg?v=1846326795495253585 1080w" sizes="503px">
          </a>
        </div>
      </div>


    </section>
  </Transition>
  <Transition> 
    <section v-if="activeSection === 'productType'" 
             :class="['content-panel', { 'open': activeSection === 'productType' }]" >
      <!-- Content for ТИП ПРОДУКТУ -->
      <div class="content-container">
        <div class="container-links">
          <ul class="submenu-links" v-for="product_type in brands.product_types" :key="product_type.name">
            <li class="submenu-grid-items" >
                <a :href="'/product-type/'+product_type.slug"  class="gm-submenu-link">
                <span class='submenu-item-text'>{{product_type.name}}</span> </a>
            </li>
          </ul>
        </div>

        <div class="container-imgs">
          <a href="#">
            <img srcset="//nichebeautylab.com/cdn/shop/files/1647419898_0_40x.jpg?v=11090579158224605666 40w, //nichebeautylab.com/cdn/shop/files/1647419898_0_100x.jpg?v=11090579158224605666 100w, //nichebeautylab.com/cdn/shop/files/1647419898_0_140x.jpg?v=11090579158224605666 140w, //nichebeautylab.com/cdn/shop/files/1647419898_0_180x.jpg?v=11090579158224605666 180w, //nichebeautylab.com/cdn/shop/files/1647419898_0_250x.jpg?v=11090579158224605666 250w, //nichebeautylab.com/cdn/shop/files/1647419898_0_260x.jpg?v=11090579158224605666 260w, //nichebeautylab.com/cdn/shop/files/1647419898_0_275x.jpg?v=11090579158224605666 275w, //nichebeautylab.com/cdn/shop/files/1647419898_0_305x.jpg?v=11090579158224605666 305w, //nichebeautylab.com/cdn/shop/files/1647419898_0_440x.jpg?v=11090579158224605666 440w, //nichebeautylab.com/cdn/shop/files/1647419898_0_610x.jpg?v=11090579158224605666 610w, //nichebeautylab.com/cdn/shop/files/1647419898_0_720x.jpg?v=11090579158224605666 720w, //nichebeautylab.com/cdn/shop/files/1647419898_0_930x.jpg?v=11090579158224605666 930w, //nichebeautylab.com/cdn/shop/files/1647419898_0_1080x.jpg?v=11090579158224605666 1080w" data-sizes="auto" width="" height="" data-widths="[40, 100, 140, 180, 250, 260, 275, 305, 440, 610, 720, 930, 1080]" class="lazyautosizes lazyloaded" alt="" data-srcset="//nichebeautylab.com/cdn/shop/files/1647419898_0_40x.jpg?v=11090579158224605666 40w, //nichebeautylab.com/cdn/shop/files/1647419898_0_100x.jpg?v=11090579158224605666 100w, //nichebeautylab.com/cdn/shop/files/1647419898_0_140x.jpg?v=11090579158224605666 140w, //nichebeautylab.com/cdn/shop/files/1647419898_0_180x.jpg?v=11090579158224605666 180w, //nichebeautylab.com/cdn/shop/files/1647419898_0_250x.jpg?v=11090579158224605666 250w, //nichebeautylab.com/cdn/shop/files/1647419898_0_260x.jpg?v=11090579158224605666 260w, //nichebeautylab.com/cdn/shop/files/1647419898_0_275x.jpg?v=11090579158224605666 275w, //nichebeautylab.com/cdn/shop/files/1647419898_0_305x.jpg?v=11090579158224605666 305w, //nichebeautylab.com/cdn/shop/files/1647419898_0_440x.jpg?v=11090579158224605666 440w, //nichebeautylab.com/cdn/shop/files/1647419898_0_610x.jpg?v=11090579158224605666 610w, //nichebeautylab.com/cdn/shop/files/1647419898_0_720x.jpg?v=11090579158224605666 720w, //nichebeautylab.com/cdn/shop/files/1647419898_0_930x.jpg?v=11090579158224605666 930w, //nichebeautylab.com/cdn/shop/files/1647419898_0_1080x.jpg?v=11090579158224605666 1080w" sizes="637px">
          </a>
        </div>
      </div>

    </section>
  </Transition>

</template>

<script>
import logo from '@/assets/img/logo.svg';
import wish_list from '@/assets/img/ico/wishlist.svg';
import SidebarComponent from '@/components/Sidebar.vue';
import '@/assets/css/Navbar.css';
import { Transition } from 'vue';
import instance from '@/api/axiosInstance';
import { mapGetters } from 'vuex';

export default {
  components: {
    SidebarComponent,
    Transition,
  },
  data() {
    return {
      showSearch: false,
      showSidebar: false,
      dropdown: null,
      activeSection: null,
      is_active: false, 
      brands: [],
      baseURL: instance.defaults.baseURL, 
      searchQuery: '',
      products: [],      // Масив продуктів
      filteredProducts: []  // Масив відфільтрованих продукт
    };
  },
  computed: {
    ...mapGetters({
      cartCount: 'cart/cartItemCount',  // Імпортуємо кількість товарів у кошику
      wishlistItemCount: 'wishlist/wishlistItemCount'
    }),
    logo() {
      return logo;
    },
    wish_list() {
      return wish_list;
    }
  },
  mounted() {
    this.getBrands()
    this.getProducts();
    this.fetch_collection_status();
  },
  methods: {
    closeAll() { 
      this.activeSection = null;
    },
    go_to_collections() {
      const baseUrl = window.location.origin;  // Gets the base URL of your application
      window.location.href = `${baseUrl}/products_collection`;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
      this.activeSection = null;
      this.searchQuery = '';
      this.filteredProducts = [];
    },
    handleClick(navigate) {
    // Закриваємо пошуковий бар перед переходом
    this.toggleSearch();

    // Викликаємо навігацію вручну
    navigate();
  },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    toggleDropdown(section) {
      this.activeSection = this.activeSection === section ? null : section;
    },
    toggleCart() {
      this.$emit('toogle_cart');
      this.activeSection = null;
      
    },
    toggleWishlist() {
      this.$emit('toogle_wishlist')
      this.activeSection = null;
    },
    async getBrands() {
      try {
        const response = await instance.get('/api/v1/shop/navbar/')
        console.log(response.data);
        this.brands = response.data
      } catch (error) {
        console.error('Error fetching brands:', error)
      }
    },
   
    onSearchInput() {
      if (this.searchQuery.length >= 2) {
        this.filteredProducts = this.products.filter(product =>
          product.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          product.variants.some(variant => variant.code.includes(this.searchQuery))
        );
      } else {
        this.filteredProducts = [];
      }
    },
    async fetch_collection_status() {
      try {
        const response = await instance.get('/api/v1/shop/collections/');
        this.is_active = response.data.collections[0].is_active;
      } catch (error) {
        console.error('Error fetching collection status:', error);
      }
    },
    async getProducts() {
      try {
        const response = await instance.get('/api/v1/shop/all-product/');
        this.products = response.data;
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },
    clearSearch() {
      this.searchQuery = '';
      this.filteredProducts = [];
    }
  },

  
};
</script>


<style scoped>
.container {
  position: relative;
}

.content-panel {
  position: absolute; /* або fixed, якщо потрібно фіксувати секцію відносно вікна */
  width: 100%;
  z-index: 10; /* Важливо для перекриття інших блоків */
  background: #fff;
}
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from, .v-leave-to /* .v-leave-active in <2.1.8 */ {
  opacity: 0;
}
.content-container {
  display: flex;
  padding: 20px;
  justify-content: space-around;
}
.container-imgs {
  gap: 30px;
  display: flex;
}
.container-imgs a{
  display: flex;
  flex-direction: column;
}
.submenu-grid {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  margin-left: 0;
  margin-right: 0;
  min-width: 100%;
  list-style: none;
}
.submenu-links {
  list-style: none;
}
.submenu-grid-items {
  text-wrap: nowrap;
}
.submenu-item-text {
  font-family: MaisonNeue, sans;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 2px;
  line-height: 25px;
  text-align: center;
  text-transform: uppercase;

}

.submenu-grid-img {
  list-style: none;
}
.submenu-grid-img a {
  display: flex;
  flex-direction: column
}
.submenu-img {
  display: flex;
  justify-content: center;
}
@media (max-width: 1100px) {
  .container-imgs a img {
    height: 175px;
    width: auto;
  }
  .submenu-item-text {
    font-size: 12px;
  }
}
@media (max-width: 900px) {
  .container-imgs a img {
    height: 165px;
    width: auto;
  }
  .submenu-item-text {
    font-size: 11px;
  }
}
@media (max-width: 800px) {
  .container-imgs a img {
    height: 150px;
    width: auto;
  }
  .submenu-item-text {
    font-size: 11px;

  }
}
@media (max-width:768px) {
  .content-panel open {
    display:none;
  }
}

.search-bar {
  width: 100%;
}

.search-bar button {
  color: black;
}
.close-search {
  background: none;
  border: none;
  cursor: pointer;
  color: black;
}

.products-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
}

.product-card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  width: 200px;
  height: 300px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.product-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
.product-card h3{
  height: 70px;
  overflow: hidden;
}

.product-img {
  max-width: 100%;
  height: 160px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.price {
  font-size: 16px;
  color: #333;
}

.old-price {
  text-decoration: line-through;
  color: red;
  margin-right: 10px;
}

.discount-price {
  color: green;
}

@media (max-width: 768px) {
  .product-card {
    width: 150px;
  }
}

@media (max-width: 384px) {
  .product-card {
    width: 120px;
  }
}
.tabs { 
  margin: 0;
  display: flex;
  justify-content: space-around;
}
.tabs button {
    position: relative; /* Необхідно для позиціонування псевдоелемента */
    background: transparent;
    border: none;
    cursor: pointer;
    font-weight: 600;
    padding: 10px 15px;
    color: #000; /* Колір тексту */
    text-transform: uppercase;
    outline: none;
    transition: color 0.3s ease;
}

.tabs button:hover {
    color: #000; /* Опціонально: змінює колір тексту при наведенні */
}

.tabs button::after {
    content: '';
    position: absolute;
    bottom: 0; /* Підкреслення знаходиться внизу кнопки */
    left: 0;
    width: 0;
    height: 2px; /* Товщина підкреслення */
    background-color: #000; /* Колір підкреслення */
    transition: width 0.3s ease; /* Анімація розширення підкреслення */
}

.tabs button:hover::after {
    width: 100%; /* Розширення підкреслення на всю ширину кнопки */
}
.header__qty {
    position: absolute;
    display: block;
    width: 18px;
    height: 18px;
    background-color:red;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    border-radius: 50px;
    margin-top: -30px;
    margin-left: 12px;
    font-size: 12px;
    line-height: 12px;}
    .no-results {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-top: 20px;
  padding: 10px; /* Додано внутрішній відступ */
  border: 1px solid #ddd; /* Додано бордер */
  border-radius: 5px; /* Згладження бордера */
  background-color: #f9f9f9; /* Світлий фон для повідомлення */
}

</style>